/* eslint-disable max-lines*/
import moment from 'moment';
/**
 * @override
 * @param {*} intervener interviniente
 * @param {*} now Ahora
 */
export function isMinor(intervener, now = moment()) {
  return intervener.birthdate ? now.diff(moment(intervener.birthdate), 'years') < 18 && intervener.intervener_type === 'F' : false;
}

/**
 * @override
 * @param {*} document_expiration_date Fecha de cumpleaños
 * @param {*} now Ahora
 */
export function isDocumentExpired(document_expiration_date, now = moment()) {
  return now.isAfter(moment(document_expiration_date));
}

/* eslint-disable max-len */
/* eslint-disable complexity */
import DispatchersMixin from '@/mixins/dispatchers';
const PeriodicOperations = () =>
  import(/* webpackChunkName: "PeriodicOperations" */ '@/views/operation-details/operations-add/operation-add-execute-operation/periodic-operations');
const PostalAddressDetail = () =>
  import(/* webpackChunkName: "IntervenerDetailRelated" */ '@/components/interveners/postal-address-detail');
const IntervenerSearcher = () =>
  import(/* webpackChunkName: "interveners" */ '@/views/shared/related-interveners/intervener-searcher');
const IntervenerForm = () =>
  import(/* webpackChunkName: "interveners" */ '@/views/shared/related-interveners/intervener-form');
const ContributorForm = () =>
  import(/* webpackChunkName: "interveners" */ '@/views/shared/related-contributors/contributor-form');

export default {
  name: 'SubscriptionOperation',
  mixins: [DispatchersMixin],
  props: {
    newOperationState: {
      type: Object,
      required: true
    },
    periodic: {
      type: Boolean,
      required: false,
      default: false
    },
    productMinimums: {
      type: Object,
      required: true
    }
  },
  components: {
    ContributorForm,
    IntervenerForm,
    IntervenerSearcher,
    PeriodicOperations,
    PostalAddressDetail
  },
  watch: {
    'newOperationState.hasNewContributor'(needContributor) {
      if (needContributor) {
        const uuidAccount = this.newOperationState.account.uuid;
        this.$accountsService.getAccountContriubutors(uuidAccount).then(res => {
          const contributors = res.data.account_contributors;
          if (contributors.length) {
            this.hasPreviousContributor = true;
            this.newOperationState.hasNewContributor = true;
            this.newOperationState.contributorType = contributors[0].contributor_type;
            this.newOperationState.oldContributorUUID = contributors[0].uuid;
            this.newOperationState.newContributors = contributors;
            this.newOperationState.existingContributor = true;
          }
        });
      }
    }
  },
  /**
   * @override
   */
  data() {
    return {
      maxYearContribution: null,
      payMethodOptions: [],
      updatesCount: null,
      createContributor: false,
      newContributor: {
        account_intervener_role: ''
      },
      contributorsTablefields: [
        {
          key: 'name',
          label: 'Nombre del aportante',
          class: 'contributor_name'
        },
        {
          key: 'birthdate',
          label: 'Fecha nacimiento',
          class: 'birthdate'
        },
        {
          key: 'document_id',
          label: 'Documento',
          class: 'document_id'
        },
        {
          key: 'contributor_type',
          label: 'Tipo de aportante',
          class: 'role'
        },
        {
          key: 'mailing',
          label: 'Medio de correspondencia',
          class: 'mailing'
        },
        {
          key: 'actions',
          label: '',
          class: 'actions'
        }
      ],
      moreBeneficiaries: false,
      beneficiary: {},
      isFirstContribution: true,
      currentBenefinicaries: [],
      mailingKey: 0,
      isDisabledPerson: false,
      isLoading: false,
      hasPreviousContributor: false
    };
  },
  async mounted() {
    this.loadPaymentOptions()
    try {
      const result = await this.$intervenersService.getIntervenersByUUIId(this.newOperationState.ordering.uuid, {});
      this.isDisabledPerson = result.data.intervener.personal_data.is_disabled_person;
    } catch (err) {
      console.log(err);
    }
  },

  /**
   * @override
   */
  computed: {
    /**
     * @return {Number} shares calculated from input and net asset value
     */
    expirationDate() {
      const days = Number(this.newOperationState.configs['OP_TIME_TO_LIVE']);
      const today = new Date();
      const expiration = new Date();
      expiration.setDate(today.getDate() + days);
      return expiration;
    },
    /**
   * @return {Number} minimal amount
   */
    minSuscription() {
      return this.productMinimums.minimum_investment;
    },

    maxSuscription() {
      return this.productMinimums.maximum_investment ? this.productMinimums.maximum_investment : Infinity;
    },
    isFamily() {
      const roles = this.newOperationState.ordering ? this.newOperationState.ordering.account_roles : undefined;
      if (!roles) {
        return false;
      }
      let result = false;
      roles.forEach(role => {
        result = role.account_intervener_role === 'APORTANTE_CONYUGE';
      });
      return result;
    },
    isDisabledBankAccount() {
      if (
        this.newOperationState.operationObj.pay_method &&
        this.newOperationState.operationObj.pay_method.key === 'CHEQUE'
      ) {
        this.newOperationState.bankAccount = undefined;
        return true;
      }
      return false;
    }
  },
  methods: {
    async loadPaymentOptions() {
      try {
        const resp = await this.$operationsService.getPaymentMethods();
        // this.payMethodOptions = resp.data
        const options  = resp.data
        // Aplicar las reglas según la operación
        this.setMethods(options); 
      } catch (err) {
        console.error('Error fetching payment methods:', err);
      }
    },
    
    setMethods(arr) {
      switch (this.selectedOperation) {
        case "APORTACION":
        case "SUSCRIPCION":
          this.payMethodOptions = arr.filter(
            elem => elem.value !== "DOMICILIACION"
          );
          break;
        case "SOLICITUD_REEMBOLSO_PERIODICO":
        case "SOLICITUD_SUSCRIPCION_PERIODICA":
          this.payMethodOptions = arr.filter(
            elem => elem.value === "TRANSFERENCIA"
          );
          break;
        case "SOLICITUD_APORTACION_PERIODICA":
          this.payMethodOptions = arr.filter(
            elem => elem.value === "DOMICILIACION"
          );
          break;
        default:
          this.payMethodOptions = arr;
          break;
      }
      // Auto-select if there's only one payment method
      if (this.payMethodOptions.length === 1) {
        this.newOperationState.operationObj.pay_method = this.payMethodOptions[0];
      }
    },

    resetNewContributors() {
      this.newOperationState.newContributors = [];
      this.newOperationState.contributorType = this.ordering;
      this.maxContribution();
    },
    /**
     * @param {String} grossAmount  net_amount value
     */
    onInputGrossAmount(grossAmount) {
      this.newOperationState.operationObj.netAmount = grossAmount;
      this.newOperationState.operationObj.shares = 0.0;
      this.newOperationState.operationObj.commission = 0;
      this.newOperationState.operationObj.withholding = 0;
    },
    /**
     * Clean calculated values waiting for RD response
     */
    cleanSimulatedValues() {
      this.newOperationState.operationObj.commission = null;
      this.newOperationState.operationObj.withholding = null;
      this.newOperationState.operationObj.netAmount = null;
      this.newOperationState.operationObj.shares = null;
    },
    /**
     * Retrieve bank accounts data
     */
    getBankAccountsData() {
      this.$accountsService.getAccountBankAccounts(this.newOperationState.account.uuid, {}).then(res => {
        const fake = { iban_code: 'Nueva cuenta', is_fake: true };
        // this.newOperationState.account.bankAccounts = res.data.bank_accounts.filter(ba => ba.is_validated);
        this.newOperationState.account.bankAccounts = res.data.bank_accounts;
        this.newOperationState.account.bankAccounts.push(fake);
        this.newOperationState.bankAccount = null;
        this.updatesCount++;
      });
    },
    /**
     * Handle new account
     * @param {Object} selectedBankAccount selectedAccount
     */
    onNewAccount(selectedBankAccount) {
      this.newOperationState.keyAddOperation++;
      if (selectedBankAccount && selectedBankAccount.is_fake) {
        this.newOperationState.bankAccount = null;
        const item = {
          active: true,
          name: this.newOperationState.account.id_object,
          route: {
            name: 'accounts_uuid',
            params: {
              uuid: this.newOperationState.account.uuid
            },
            force: true
          }
        };
        localStorage.setItem(`tabs_account_${this.newOperationState.account.uuid}`, 4);
        this.setMenuTab(item);
      }
    },
    /**
     * Check if the intervener selected has rol 'TITULAR' or not
     * @param {*} selection Interviniente seleccionado
     * @return {Boolean} True if has role 'TITULA' false if not
     */
    isHolder(selection) {
      if (this.newOperationState.isEdition) {
        return false;
      }
      const isHolder = this.newOperationState.account.interveners.some(intervener => {
        let isIntervenerHolder = false;
        if (intervener.uuid === selection.uuid) {
          isIntervenerHolder = intervener.account_roles.some(roles => {
            return roles.account_intervener_role === 'TITULAR';
          });
        }
        return isIntervenerHolder;
      });
      return isHolder;
    },
    /**
     * Añadir aportante nuevo
     * @param {*} contributor aportante a crea
     */
    addContributor(contributor) {
      this.newOperationState.newContributors.push(this.formatContributor(contributor));
      this.createContributor = false;
    },
    constructFullName(intervener) {
      let name = intervener.name ? `${intervener.name}` : '';
      name += intervener.lastname_1 ? ` ${intervener.lastname_1}` : '';
      name += intervener.lastname_2 ? ` ${intervener.lastname_2}` : '';
      name = name.trim();
      return name;
    },
    /**
     * Devuelve opciones de correspondencia
     * @param {*} intervener Interviniente
     * @return {*} listado
     */
    mailingOptions(intervener) {
      const options = [];
      if (intervener.email) {
        options.push({
          mailing_type: 'EMAIL',
          options: [{ key: 'EMAIL', value: intervener.email }]
        });
      }
      if (intervener.postal_addresses) {
        options.push({
          mailing_type: 'POSTAL',
          options: [...intervener.postal_addresses.map(value => ({ key: `POSTAL-${value.uuid}`, value }))]
        });
      }
      return options;
    },
    /**
     *
     * @param {*} intervener Interviniente a formatear
     * @return {*} Interviniente formateado
     */
    formatContributor(intervener) {
      this.newContributor = {};
      this.newContributor['uuid'] = intervener.uuid;
      this.newContributor['name'] = intervener.personalData ? intervener.personalData['name'] : intervener['name'];
      this.newContributor['lastname_1'] = intervener.personalData
        ? intervener.personalData['lastname_1']
        : intervener['lastname_1'];
      this.newContributor['lastname_2'] = intervener.personalData
        ? intervener.personalData['lastname_2']
        : intervener['lastname_2'];
      this.newContributor['document_id'] = intervener.personalData
        ? intervener.personalData['document_id']
        : intervener['document_id'];
      this.newContributor['document_type'] = intervener.personalData
        ? intervener.personalData['document_type']
        : intervener['document_type'];
      this.newContributor['document_expiration_date'] = intervener.personalData
        ? intervener.personalData['document_expiration_date']
        : intervener['document_expiration_date'];
      this.newContributor['is_document_expired'] = isDocumentExpired(this.newContributor['document_expiration_date']);
      this.newContributor['is_document_permanent'] = intervener.personalData
        ? intervener.personalData['is_document_permanent']
        : intervener['is_document_permanent'];
      this.newContributor['email'] = intervener.contactData ? intervener.contactData['email'] : intervener['email'];
      this.newContributor['birthdate'] = intervener.personalData
        ? intervener.personalData['birthdate']
        : intervener['birthdate'];
      this.newContributor['intervener_type'] = intervener.personalData
        ? intervener.personalData['intervener_type']
        : intervener['intervener_type'];
      this.newContributor['is_minor'] = isMinor(this.newContributor);
      this.newContributor['postal_addresses'] = intervener.postal_addresses || intervener.postalData;
      this.newContributor['postal_address'] = intervener.postal_addresses
        ? intervener.postal_addresses[0]
        : intervener.postal_address;
      this.newContributor['mailing_type'] = intervener['mailing_type'];
      this.newContributor['_data'] = intervener;
      switch (intervener['mailing_type']) {
        case 'EMAIL':
          this.newContributor['mailing'] = {
            key: 'EMAIL',
            value: this.newContributor['email']
          };
          break;

        case 'POSTAL':
          if (this.newContributor['postal_address']) {
            this.newContributor['mailing'] = {
              key: `POSTAL-${this.newContributor['postal_address'].uuid}`,
              value: this.newContributor['postal_address']
            };
          }
          break;

        default:
          break;
      }
      this.newContributor['account_intervener_role'] = this.newOperationState.contributorType;
      return this.newContributor;
    },

    /**
     * Elimina relación
     * @param {*} row interviniente
     */
    removeRelation() {
      this.newOperationState.newContributors = [];
      this.newOperationState.hasMailingTypeNewContributor = false;
    },
    /**
     * Guarda mailing_type
     * @param {*} val Valor
     */
    setMailingType(val) {
      this.newOperationState.hasMailingTypeNewContributor = true;
      const _m = this.newOperationState.newContributors[0];
      _m['mailing_type'] = val.key === 'EMAIL' ? 'EMAIL' : 'POSTAL';
      _m['uuid_postal_address'] = _m['mailing_type'] === 'POSTAL' ? val.value.uuid : undefined;
      this.mailingKey++;
    },
    /**
     * Guarda mailing_type
     */
    unsetMailingType() {
      this.newOperationState.hasMailingTypeNewContributor = false;
    },
    /**
     * Guarda el beneficiario en el array
     */
    createBeneficiary() {
      if (!this.beneficiary.given_name || !this.beneficiary.family_name || !this.beneficiary.document_id) return;
      this.newOperationState.newBeneficiaries.push(this.beneficiary);
      this.moreBeneficiaries = false;
      this.beneficiary = {};
    },
    /**
     * @param {Number} index index of element to remove
     */
    removeBeneficiary(index) {
      this.newOperationState.newBeneficiaries.splice(index, 1);
    },
    /**
     * carga las operaciones
     */
    async loadAccountOperations() {
      try {
        const cfgAccountOperations = {};
        cfgAccountOperations.params = {};
        cfgAccountOperations.params['$filter'] = `{"key_product":[{"in": "${
          this.newOperationState.productSelected.key_name
        }" }]}`;
        const res = await this.$accountsService.getAccountOperations(
          this.newOperationState.account.uuid,
          cfgAccountOperations
        );
        this.isFirstContribution = res.data.related_operations.length === 0;
      } catch (error) {
        console.error(error);
      }
    },
    async loadBeneficiaries() {
      try {
        const res = await this.$accountsService.getBeneficiaries(this.newOperationState.account.uuid);
        this.currentBenefinicaries = res.data.account_beneficiaries.filter(
          beneficiary => beneficiary.key_product === this.newOperationState.productSelected.key_name
        );
      } catch (error) {
        console.error(error);
      }
    },
    async loadContributor() {
      try {
        if (this.newOperationState.isEdition) {
          const op = await this.$operationsService.getOperationsByUUId(this.newOperationState.uuid_operation);

          if (op.data.operation.contributor) {
            const res = await this.$accountsService.getAccountContriubutors(op.data.operation.account_id);
            const contributor = res.data.account_contributors.filter(
              c => c.document_id === op.data.operation.contributor.document_id
            );

            this.newOperationState.hasNewContributor = true;
            this.newOperationState.contributorType = op.data.operation.contributor.role;
            this.newOperationState.oldContributorUUID = op.data.operation.contributor.uuid;
            this.newOperationState.newContributors = contributor;
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    minContribution() {
      const isFil = this.newOperationState.productSelected.juridical_form === "F.I.L.";
      const investorClass = this.newOperationState.account.investor_class;

      if (isFil) {
        switch (investorClass) {
          case "MINORISTA":
            this.newOperationState.min_contribution = 10000;
            return;
          case "PROFESIONAL":
            this.newOperationState.min_contribution = 0.01;
            return;
        }
      }

      let minimal = this.minSuscription;
      if (
        this.newOperationState.operationTypeSelected.key_name === 'SOLICITUD_APORTACION_PERIODICA' &&
        this.newOperationState.operationObj.per_period
      ) {
        switch (this.newOperationState.operationObj.per_period.key) {
          case 'MENSUAL':
            minimal = this.newOperationState.productSelected.minimum_periodic_investment.MENSUAL;
            break;
          case 'TRIMESTRAL':
            minimal = this.newOperationState.productSelected.minimum_periodic_investment.TRIMESTRAL;
            break;
          case 'SEMESTRAL':
            // TODO: deberia estar semestral en la base de datos, mientras ponemos el doble de la trimestral
            minimal = Number(this.newOperationState.productSelected.minimum_periodic_investment.TRIMESTRAL) * 2;
            break;
          case 'ANUAL':
            minimal = this.newOperationState.productSelected.minimum_periodic_investment.ANUAL;
            break;
          default:
            break;
        }
      }
      this.newOperationState.min_contribution = minimal;
    },
    /**
     *
     * @param {*} type  Optional parameter to indicate operationType Selected
     */
    maxContribution() {
      const orderingType =
        this.newOperationState.contributorType || this.isDisabledPerson === true ? 'APORTANTE_MINUSVALIDO' : null;

      const maxContributionDefault =
        this.maxYearContribution.limite_participe - (this.maxYearContribution.participe_anyo || 0);
      const maxContributionByContributorType = {
        APORTANTE_FAMILIAR:
          this.maxYearContribution.limite_fam_minus - (this.maxYearContribution.minusvalido_anyo || 0),
        APORTANTE_CONYUGE: this.maxYearContribution.limite_conyuge - (this.maxYearContribution.conyuge_anyo || 0),
        APORTANTE_MINUSVALIDO:
          this.maxYearContribution.limite_minusvalido - (this.maxYearContribution.minusvalido_anyo || 0)
      };

      if (this.needMaxContribution()) {
        this.newOperationState.max_contribution =
          maxContributionByContributorType[orderingType] || maxContributionDefault;
      }
    },
    needMaxContribution() {
      return (
        this.maxYearContribution &&
        (this.newOperationState.operationTypeSelected.key_name.includes('APORTACION') ||
          !this.newOperationState.operationObj.per_period)
      );
    },
    setContributorType(type = undefined) {
      this.newOperationState.contributorType = type;
      this.maxContribution();
    }
  },

  /**
   * @override
   */
  async beforeMount() {
    this.isLoading = true;
    if (this.newOperationState.operationObj.grossAmount) {
      this.onInputGrossAmount(this.newOperationState.operationObj.grossAmount);
    }
    if (
      ['APORTACION', 'SOLICITUD_APORTACION_PERIODICA'].includes(this.newOperationState.operationTypeSelected.key_name)
    ) {
      try {
        // const res = await this.$intervenersService.getMaxYearContribution(this.newOperationState.ordering.uuid);
        // this.maxYearContribution = res.data.intervener_limit ;

        const response = await this.$usersService.getConfigVarByKey('MAX_APORTATION');

        this.maxYearContribution = JSON.parse(response.data.configuration.value);
        this.newOperationState.contributorType = this.newOperationState.newContributors.length
          ? this.newOperationState.newContributors[0].contributor_type
          : undefined;
        this.maxContribution();
      } catch (err) {
        this.$toast.error('Error', 'Error consultado limite a RD');
        console.error('maxContribution', err);
        this.isLoading = false;
      }
      await this.loadAccountOperations();
      await this.loadBeneficiaries();
      await this.loadContributor();
    }
    this.minContribution();
    this.isLoading = false;
  }
};
